const bronze = '#78481f'
const iron = '#9a9086'
const steel = '#46525c'
const silver = '#c6cfcf'
const quartz = '#f0b8f7'
const opal = '#6fa8b8'
const agate = '#e0c9a6'
const jade = '#3f8f6b'
const amber = '#e8a020'
const gold = '#f2e261'
const platinum = '#086f6b'
const titanium = '#b8bcc0'
const tungsten = '#3f4650'
const rhodium = '#dde3e8'
const iridium = '#4d6b8a'
const topaz = '#7cc5e8'
const garnet = '#7b1d2b'
const amethyst = '#b07fe0'
const spinel = '#c2185b'
const sapphire = '#2158a6'
const emerald = '#2da955'
const ruby = '#c52121'
const diamond = '#d1fffa'
const obsidian = '#71228f'
const meteorite = '#22242b'
const adamantium = '#b0b09a'
const mithril = '#70bbba'
const orichalcum = '#c98b2e'
const nebula = '#b02a8f'
const aether = '#ded4ff'

const badgeColors = {
  bronze,
  iron,
  steel,
  silver,
  quartz,
  opal,
  agate,
  jade,
  amber,
  gold,
  platinum,
  titanium,
  tungsten,
  rhodium,
  iridium,
  topaz,
  garnet,
  amethyst,
  spinel,
  sapphire,
  emerald,
  ruby,
  diamond,
  obsidian,
  meteorite,
  adamantium,
  mithril,
  orichalcum,
  nebula,
  aether,
}

export default badgeColors
